import MenuButton from './parts/MenuButton'
import DecreaseQuantityButton from '@/features/pos/components/buttons/DecreaseQuantityButton'
import DeleteButton from '@/features/pos/components/buttons/DeleteButton'
import IncreaseQuantityButton from '@/features/pos/components/buttons/IncreaseQuantityButton'
import { FC, memo } from 'react'
import { StyleSheet, View } from 'react-native'

export interface ActionButtonsProps {
    id: string
    decreaseDisabled: boolean
    hasAutomaticContainers: boolean
    onDelete: (id: string) => void
    onChangeQuantity: (id: string, changeQuantity: number) => void
    onEditAutomaticContainers: (id: string) => void
}

const ActionButtons: FC<ActionButtonsProps> = ({
    id,
    decreaseDisabled,
    hasAutomaticContainers,
    onDelete,
    onChangeQuantity,
    onEditAutomaticContainers,
}) => {
    return (
        <View style={styles.container}>
            <View style={styles.innerContainer}>
                <MenuButton
                    id={id}
                    hasAutomaticContainers={hasAutomaticContainers}
                    onEditAutomaticContainers={onEditAutomaticContainers}
                />
                <DeleteButton onPress={() => onDelete(id)} />
            </View>
            <View style={styles.innerContainer}>
                <DecreaseQuantityButton
                    disabled={decreaseDisabled}
                    onPress={() => onChangeQuantity(id, -1)}
                />
                <IncreaseQuantityButton onPress={() => onChangeQuantity(id, 1)} />
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 8,
        flexWrap: 'wrap',
    },
    innerContainer: {
        flexDirection: 'row',
        gap: 8,
    },
})

export default memo(ActionButtons)
